module.exports = __webpack_public_path__ + "static/img/014.35fb769.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/lkpy/014.png
// module id = 7xFG
// module chunks = 0